
import { Component, Prop, Vue, Provide } from 'vue-property-decorator';
import vmosServices from '@/services/vmosData';
import FlyoutGroup from './components/FlyoutGroup/FlyoutGroup.vue';
import { FlyoutData, FlyoutKeys, FlyoutDataI18n, FlyoutDataItem, FlyoutDataVehiclesData } from '@/lib/interfaces';

@Component({
  name: 'FlyoutWrapper',
  components: {
    FlyoutGroup,
  },
})
export default class FlyoutWrapper extends Vue {
  @Prop({ required: true, type: String }) private country!: string;
  @Prop({ required: true, type: String }) private language!: string;
  @Provide('i18n') private i18n: FlyoutDataI18n = { values: {} };
  @Provide('vehiclesData') private vehiclesData: FlyoutDataVehiclesData = { values: {} };
  // TODO: we need to change the context eventually to something dynamic
  @Provide('context') private context = 'OWF';
  private importedData: FlyoutData = {} as FlyoutData;
  //We use this variable to sort the different menu groups in a specified order
  private groupsSort: string[] = ['allModels', 'filters', 'subGroups', 'groups'];
  private secondLevelOpen = false;
  private sublevelVehicles: any[] = [];
  private selectedSubgroupName = '';

  created(): void {
    this.loadData();
  }

  async loadData(): Promise<void> {
    this.importedData = await vmosServices.getLiveSummary({
      market: this.country,
      language: this.language,
      context: this.context,
    });
    this.i18n.values = this.importedData['i18n'];
    this.vehiclesData.values = this.importedData['vehiclesData'];
  }

  get navCategories(): FlyoutDataItem[] {
    //If imported data is not loaded yet or the groups inside, we return an empty array
    if (!this.importedData || !this.importedData.groups) return [];
    const importedDataCopy = { ...this.importedData, groups: [...this.importedData.groups] };
    const filteredData = (({ i18n, cards, vehiclesData, ...o }) => o)(importedDataCopy);
    filteredData.allModels = [];
    const categories = Object.keys(filteredData)
      .sort((a: any, b: any) => {
        return this.groupsSort.indexOf(a) - this.groupsSort.indexOf(b);
      })
      .reduce((obj: any, key: any) => {
        // We have here a special case, where an Item is coming  inside a group from Backend,
        // but we need it as it's own group, so we take it out of the group and create a new one
        if (key === 'groups') {
          const allModelsItem = filteredData.groups.find((item: any) => item.nameI18nKey === 'group.all.name');
          const eqItem = filteredData.groups.find((item: any) => item.nameI18nKey === 'group.alternative-fuel.name');
          if (allModelsItem) {
            filteredData.groups.splice(filteredData.groups.indexOf(allModelsItem), 1);
            obj['allModels'] = [allModelsItem];
          }
          // If EQ Brand is still present we remove it from the groups object
          // TODO: After EQ brand sundown on BE as well, we can remove this.
          if (eqItem) {
            filteredData.groups.splice(filteredData.groups.indexOf(eqItem), 1);
          }
        }
        obj[key] = filteredData[key as FlyoutKeys];
        return obj;
      }, {});
    return categories;
  }

  parseVehicle(vehicle: any): FlyoutDataItem {
    return {
      link: vehicle.ctas['PRODUCT_PAGE'].url,
      nameOverrideI18nKey: vehicle.nameOverrideI18nKey,
      vehicleDataId: vehicle.vehicleDataId,
      isNew: vehicle.tags?.includes('new'),
    };
  }

  getSubgroupVehicles(cardsId: string[]): void {
    const vehicles = cardsId.reduce((newArray: any[], cardId) => {
      const carData = this.importedData.cards?.[cardId];
      return !carData ? newArray : [...newArray, this.parseVehicle(carData)];
    }, []);

    this.sublevelVehicles = vehicles;
  }

  onOpenSubmenu(event: any): void {
    this.secondLevelOpen = true;
    this.selectedSubgroupName = this.i18n.values[event.subgroup.nameOverrideI18nKey];
    this.getSubgroupVehicles(event.subgroup.cardsId);
    Vue.nextTick(() => {
      const elementRef = this.$refs.owcFlyout as HTMLElement;
      elementRef.addEventListener('owc-header-flyout-close', async (event: any) => {
        await (this.$refs.owcFlyout as any).close(event.detail.isGlobal);
        this.secondLevelOpen = false;
      });

      // this might be temporary,
      // this code fix a problem on the external component (owc-header-flyout)
      const externalComponent = elementRef.shadowRoot;
      if (externalComponent) {
        const style = document.createElement('style');
        style.innerHTML = `
          @media only screen and (max-width: 1279px) and (min-width: 768px) {
            .owc-header-flyout__innerContent { padding: 0 24px; }
          }
        `;
        externalComponent.appendChild(style);
      }
      // fix end
    });
  }
}
